module.exports = __webpack_public_path__ + "img/story043.d26b4643.webp";